/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import BankCard from 'modules/PaymentProfile/components/BankCard';
import CreditCardPaymentProfile from 'modules/PaymentProfile/components/CreditCardPaymentProfile';
import { IPaymentProfileItem } from 'modules/PaymentProfile/reducers/type';
import { isCreditCardPaymentProfile } from 'helpers/paymentProfile';

type Props = { paymentItem: IPaymentProfileItem };
const PaymentDetail: React.FC<Props> = ({ paymentItem }) => (
    <div>
        <BankCard paymentItem={paymentItem} />
        {isCreditCardPaymentProfile(paymentItem) ? <CreditCardPaymentProfile paymentItem={paymentItem} /> : null}
    </div>
);

export default PaymentDetail;
